import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const cmpVelocityRoute: InvariantJiraRoute = {
	name: 'software-reports-velocity-cmp',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/velocity',
};
